import { WebRequest } from 'framework-ui-components';

export const cercaAnagraficaInUfficio = (codiceFiscale, codiceUfficio) => WebRequest.get('Anagrafica/CercaAnagraficaInUfficio', { codiceFiscale, codiceUfficio });

export const creaAnagraficaPersonaFisica = cmd => WebRequest.post('Anagrafica/CreaPersonaFisica', cmd);
